import { render, staticRenderFns } from "../../../components/shared/physicianSearch/BaseSearchBox.html?vue&type=template&id=35a4ca29&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "../../../components/shared/physicianSearch/SearchBox.css?vue&type=style&index=0&id=35a4ca29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4ca29",
  null
  
)

component.options.__file = "SearchBox.vue"
export default component.exports